export const groupModsByQuantity = (modifiers) => {
  return modifiers.reduce((mods, currentMod) => {
    const modIds = mods.map((mod) => mod.id);
    if (modIds.includes(currentMod.id)) {
      return mods.map((mod) => (mod.id === currentMod.id ? { ...mod, quantity: mod.quantity + 1 } : mod));
    } else {
      return [...mods, { ...currentMod, quantity: 1 }];
    }
  }, []);
};

export const getGiftCardCharges = (order) => {
  const orderItemsInThisOrder = order.items.map((item) => item.orderitemid);
  const orderFeesInThisOrder = order.order_fees.map((fee) => fee.id);
  return order.charges
    .filter((charge) => charge.tender_type === "gift_card")
    .map((charge) => {
      const totalAmountForOrderItems = charge.item_charge_fragments
        .filter((fragment) => orderItemsInThisOrder.includes(fragment.orderitem_id))
        .reduce((total, fragment) => total + fragment.total_cents, 0);

      const totalAmountForOrderFees = charge.fee_charge_fragments
        .filter((fragment) => orderFeesInThisOrder.includes(fragment.orderfee_id))
        .reduce((total, fragment) => total + fragment.total_cents, 0);

      return {
        id: charge.id,
        giftCardDisplay: `Gift Card ${charge.gift_card_last4}`,
        totalAmountForOrder: totalAmountForOrderItems + totalAmountForOrderFees,
      };
    });
};

export const calculateTotalGiftCardAmountAuthorized = (chargesFromGiftCards) => {
  return chargesFromGiftCards.reduce((total, charge) => total + charge.totalAmountForOrder, 0);
};
